// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iEeN","content":"styles_content__2AF7_","row":"styles_row__3H_Ja","footer":"styles_footer__27IXh","phraseLength":"styles_phraseLength__3uWO_"};